var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      staticClass: "col-md-12",
      attrs: { "lazy-validation": "" },
      model: {
        value: _vm.isFormValid,
        callback: function($$v) {
          _vm.isFormValid = $$v
        },
        expression: "isFormValid"
      }
    },
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { md3: "" } },
            [
              _c("v-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|numeric|max:3|max_value:120|min_value:1",
                    expression:
                      "'required|numeric|max:3|max_value:120|min_value:1'"
                  }
                ],
                attrs: {
                  label: _vm.formFields.limiteVelocidad.label,
                  id: _vm.formFields.limiteVelocidad.id,
                  "prepend-icon": "network_check",
                  "error-messages": _vm.errors.collect("velMax"),
                  "data-vv-name": "velMax",
                  counter: 3,
                  disabled: _vm.accion === 3
                },
                on: { change: _vm.limiteVelocidad },
                model: {
                  value: _vm.formFields.limiteVelocidad.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.limiteVelocidad, "value", $$v)
                  },
                  expression: "formFields.limiteVelocidad.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { md2: "" } },
            [
              _c("v-checkbox", {
                attrs: {
                  label: _vm.formFields.precision.label,
                  disabled: _vm.accion === 3
                },
                model: {
                  value: _vm.formFields.precision.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.precision, "value", $$v)
                  },
                  expression: "formFields.precision.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-card",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.formFields.precision.value,
                  expression: "formFields.precision.value"
                }
              ],
              attrs: { elevation: "0" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("div", { staticClass: "divClassLabel" }, [
                    _vm._v("Excluir")
                  ]),
                  _c("div", { staticClass: "divClassLabel" }, [
                    _vm._v("HDOP >=")
                  ]),
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|decimal|max_value:10|min_value:0.1",
                        expression:
                          "'required|decimal|max_value:10|min_value:0.1'"
                      }
                    ],
                    staticClass: "text-speeding",
                    attrs: {
                      label: _vm.formFields.hdop.label,
                      "data-vv-name": "precisionHdop",
                      "error-messages": _vm.errors.collect("precisionHdop"),
                      disabled: _vm.accion === 3
                    },
                    model: {
                      value: _vm.formFields.hdop.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.hdop, "value", $$v)
                      },
                      expression: "formFields.hdop.value"
                    }
                  }),
                  _c("div", { staticClass: "divClassLabel" }, [
                    _vm._v("N° Satélites <=")
                  ]),
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|decimal|max_value:100|min_value:2",
                        expression:
                          "'required|decimal|max_value:100|min_value:2'"
                      }
                    ],
                    staticClass: "text-speeding",
                    attrs: {
                      label: _vm.formFields.satelites.label,
                      "data-vv-name": "precisionSatelite",
                      "error-messages": _vm.errors.collect("precisionSatelite"),
                      disabled: _vm.accion === 3
                    },
                    model: {
                      value: _vm.formFields.satelites.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.satelites, "value", $$v)
                      },
                      expression: "formFields.satelites.value"
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }